import React from "react";
import { OANDA_PAIRS, OANDA_BADGES, OANDA_WORKFLOW_STEPS, ORACLE_TEST_IDS } from "@/constants/oracle";

export default function OandaPanel({ onPickPair, loading, disabled }) {
  return (
    <div className="oanda-panel">
      <div className="oanda-panel__head">
        <div className="oanda-panel__title">
          <span className="oanda-dot" /> OANDA FX INTELLIGENCE GRID
        </div>
        <div className="oanda-badges">
          {OANDA_BADGES.map((b) => (
            <span key={b} className="oanda-badge">{b}</span>
          ))}
        </div>
      </div>
      <div className="oanda-grid">
        {OANDA_PAIRS.map((p) => (
          <button
            key={p.symbol}
            type="button"
            data-testid={ORACLE_TEST_IDS.oandaPair(p.symbol)}
            className="oanda-pair"
            onClick={() =>
              onPickPair(
                `Run the full OANDA-style workflow on ${p.symbol}. Cover PERCEIVE → PLAN → ACT → SYNTHESIZE. Provide verdict, entry, target, stop, RR, sentiment, drivers, risk matrix, and time horizon outlook for ${p.symbol}.`
              )
            }
            disabled={disabled}
          >
            <span className="oanda-pair__flag" aria-hidden="true">{p.emoji}</span>
            <span className="oanda-pair__sym">{p.symbol}</span>
            <span className="oanda-pair__group">{p.group}</span>
          </button>
        ))}
      </div>
      <div className={`oanda-workflow ${loading ? "is-active" : ""}`} aria-live="polite">
        {OANDA_WORKFLOW_STEPS.map((s, i) => (
          <div key={s.id} className="oanda-workflow__step" style={{ animationDelay: `${i * 0.15}s` }}>
            <span className="oanda-workflow__bullet" />
            <div className="oanda-workflow__txt">
              <div className="oanda-workflow__label">{s.label}</div>
              <div className="oanda-workflow__detail">{s.detail}</div>
            </div>
            {i < OANDA_WORKFLOW_STEPS.length - 1 && <span className="oanda-workflow__arrow">→</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
